import React from 'react';
import styled from 'styled-components';
import niaLogoImage from '../../assets/images/NearvanaLogo.png';

interface NiaLogoProps {
  size?: number;
  className?: string;
}

const LogoContainer = styled.div<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 122, 255, 0.3);
`;

const LogoImage = styled.img<{ size: number }>`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const NiaLogo: React.FC<NiaLogoProps> = ({ size = 32, className }) => {
  return (
    <LogoContainer size={size} className={className}>
      <LogoImage
        src={niaLogoImage}
        alt="Nia AI Logo"
        size={size}
      />
    </LogoContainer>
  );
};

export default NiaLogo;

